export enum HistoricoVariavelAquecimentoColunasEnum {
    DATA = 'data',
    VARIAVEL = 'variavel',
    USUARIO = 'usuario',
}
